import axios from "../../axiosConfig";
import { truncateEmail } from "../../Utilities/utils";

export const updateDraftHoursEstimate = async ({ values, token, accounts }) => {
  if (!token || !values) throw new Error("Missing token or values data");

  const updateUrl = `/updateDraftHoursEstimate?&orderDetailId=${encodeURIComponent(values.orderDetailId)}&author=${encodeURIComponent(truncateEmail(accounts[0].username, 50))}&totalHrs=${encodeURIComponent(values.draftingHrs)}`;

  const response = await axios.put(
    updateUrl,
    null,
    {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      }
    }
  );

  return response.status;
};